export const atomic = `
  .pointer-event-child-none {
    > * {
      pointer-events: none;
    }
  }
`
